import React, {useState, useEffect} from 'react';
import {Modal, TextInput, TextArea} from '@carbon/react';

export interface FileActionModalProps {
  open: boolean;
  mode: 'edit' | 'copy' | 'delete';
  initialFileName?: string;
  initialNotes?: string;
  onClose: () => void;
  onSubmit: (data: { fileName?: string; notes?: string }) => void;
}

const FileActionModal: React.FC<FileActionModalProps> = ({
    open,
    mode,
    initialFileName = '',
    initialNotes = '',
    onClose,
    onSubmit,
}) => {
    const [fileName, setFileName] = useState(initialFileName);
    const [notes, setNotes] = useState(initialNotes);

    useEffect(() => {
        setFileName(initialFileName);
        setNotes(initialNotes);
    }, [initialFileName, initialNotes, open]);

    const isDelete = mode === 'delete';
    const heading =
      mode === 'edit'
          ? 'Edit File'
          : mode === 'copy'
              ? 'Copy File'
              : 'Delete File';
    const primaryText =
      mode === 'edit'
          ? 'Save'
          : mode === 'copy'
              ? 'Copy'
              : 'Delete';

    return (
        <Modal
            open={open}
            onRequestClose={onClose}
            modalHeading={heading}
            primaryButtonText={primaryText}
            secondaryButtonText="Cancel"
            onRequestSubmit={() => onSubmit({fileName, notes})}
            onSecondarySubmit={onClose}
            danger={isDelete}
            size="xs"
        >
            {isDelete ? (
                <div>Are you sure you want to delete this file?</div>
            ) : (
                <form className="space-y-4">
                    <TextInput
                        id="file-name-input"
                        labelText="File Name"
                        value={fileName}
                        onChange={e => setFileName(e.target.value)}
                        required
                        className="mb-4"
                    />
                    <TextArea
                        id="file-notes-input"
                        labelText="Notes (optional)"
                        value={notes}
                        onChange={e => setNotes(e.target.value)}
                        rows={4}
                        enableCounter
                        maxCount={250}
                    />
                </form>
            )}
        </Modal>
    );
};

export default FileActionModal;
